module.exports = __webpack_public_path__ + "img/cashier-banner.8174878b.png";